/**
 * Get the English name of a product
 *
 * If the product comes from the content service, we should have englishName already so let's use that
 * If the product does not have the englishName attribute, we get the name from the content service
 * If we still can't get it, we use the regular product name
 *
 * @param product - The product to get the English name from
 * @returns The English name of the product
 */
export const getEnglishProductName = (product: any) => {
    return product.englishName || undefined
}
